export enum FluteDirection {
    Unknown = 'FD_unknown',
    X = 'FD_X',
    Y = 'FD_Y',
    Any = 'FD_Any'
}
